<template>
  <div
    class="w-full max-w-md rounded-3xl bg-white p-6 shadow-[0_24px_60px_rgba(0,0,0,0.25)]"
    role="alertdialog"
    aria-labelledby="instant-request-title"
  >
    <p class="mb-4 text-sm font-semibold text-success-700">Someone wants to talk now</p>
    <div class="flex items-center gap-3">
      <Avatar :src="request.mentee.avatarUrl" size="lg" disable-lazy-loading />
      <div class="min-w-0 flex-1">
        <div id="instant-request-title" class="truncate font-semibold">
          {{ request.mentee.name }}
        </div>
        <div
          v-if="request.mentee.headline"
          class="truncate text-xs text-neutral-500"
        >
          {{ request.mentee.headline }}
        </div>
      </div>
      <span
        class="bg-success-50 text-success-800 shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold tabular-nums"
      >
        {{ label }}
      </span>
    </div>

    <p
      class="mt-3 rounded-xl bg-neutral-50 px-3 py-2.5 text-sm text-neutral-800"
    >
      {{ request.message }}
    </p>

    <div class="mt-5 flex gap-2">
      <BaseButton
        color="outline-gray"
        is-rounded
        class="flex-1 whitespace-nowrap"
        :is-disabled="store.isAnswering"
        @click="store.answer('not-now')"
      >
        Not now
      </BaseButton>
      <BaseButton
        color="solid-green"
        is-rounded
        class="flex-1 whitespace-nowrap"
        :is-disabled="store.isAnswering"
        @click="store.answer('join')"
      >
        <VideoIcon class="mr-1.5 size-4" />
        Join the call
      </BaseButton>
    </div>

    <p v-if="store.answerError" class="text-error-600 mt-2 text-xs" role="alert">
      {{ store.answerError }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Avatar from '@/shared/components/avatar/Avatar.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import VideoIcon from '~icons/lucide/video'
import { useInstantSessionsStore } from '@/modules/instant-sessions/stores/instantSessions'
import { useCountdown } from '@/modules/instant-sessions/utils/useCountdown'
import type { InstantRequestPayload } from '@/modules/instant-sessions/types'

const props = defineProps<{ request: InstantRequestPayload }>()
const store = useInstantSessionsStore()
const { label } = useCountdown(computed(() => props.request.expiresAt))
</script>
